var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClerk = function SvgClerk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-clerk-1)",
    d: "M20 26.25a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5m11.261 8.548c.532.532.479 1.412-.146 1.83A19.9 19.9 0 0 1 19.999 40a19.9 19.9 0 0 1-11.116-3.371c-.625-.419-.678-1.3-.147-1.83l4.568-4.568c.412-.413 1.053-.478 1.572-.212A11.2 11.2 0 0 0 20 31.25a11.2 11.2 0 0 0 5.122-1.231c.52-.266 1.16-.201 1.573.212z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-clerk-2)",
    d: "M31.116 3.371c.625.419.678 1.3.146 1.831L26.695 9.77c-.413.412-1.053.478-1.573.211A11.2 11.2 0 0 0 20 8.751C13.787 8.75 8.75 13.786 8.75 20c0 1.844.444 3.585 1.231 5.122.266.52.201 1.16-.212 1.572l-4.567 4.568c-.532.532-1.412.478-1.83-.147A19.9 19.9 0 0 1 0 20C0 8.955 8.954 0 20 0a19.9 19.9 0 0 1 11.116 3.371"
  })));
};
export default SvgClerk;